"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    oneOf: {
        'adv acting: shakespeare': 1,
        'adv actng/amr drama': 1,
        'adv lighting & stage design': 1,
        'ap art/2-dim design portfolio': 1,
        'ap art/3-dim design portfolio': 1,
        'ap art/drawing': 1,
        'ap history of art': 1,
        'ap music theory': 1,
        'applied music i': 1,
        'applied music ii': 1,
        'art and media communications i': 1,
        'art dsgn & prod f/adv vis art': 1,
        'art i': 1,
        'art ii ceramics': 1,
        'art ii drawing': 1,
        'art ii electronic media-art2em': 1,
        'art ii fibers': 1,
        'art ii jewelry': 1,
        'art ii painting': 1,
        'art ii photography': 1,
        'art ii printmaking': 1,
        'art ii sculpture': 1,
        'art iii ceramics': 1,
        'art iii drawing': 1,
        'art iii electronic media': 1,
        'art iii fibers': 1,
        'art iii graphic design': 1,
        'art iii history': 1,
        'art iii jewelry': 1,
        'art iii painting': 1,
        'art iii photography': 1,
        'art iii printmaking': 1,
        'art iii sculpture': 1,
        'art iv ceramics': 1,
        'art iv drawing': 1,
        'art iv electronic media-art4em': 1,
        'art iv fibers': 1,
        'art iv graphic design-art4grap': 1,
        'art iv jewelry': 1,
        'art iv painting': 1,
        'art iv photography': 1,
        'art iv printmaking': 1,
        'art iv sculpture': 1,
        'art, departmentalized grade 6': 1,
        // 'art, grade 1': 1, // here because subject area is fine arts //deletion edit 2024
        // 'art, grade 2': 1, // here because subject area is fine arts //deletion edit 2024
        // 'art, grade 3': 1, // here because subject area is fine arts //deletion edit 2024
        // 'art, grade 4': 1, // here because subject area is fine arts //deletion edit 2024
        // 'art, grade 5': 1, // here because subject area is fine arts //deletion edit 2024
        'art, grade 6': 1,
        'art, grade 7': 1,
        'art, grade 8': 1,
        'childrens theatre': 1,
        'comtemp studies in dance i': 1,
        'comtemp studies in dance ii': 1,
        'comtemp studies in dance iii': 1,
        'comtemp studies in dance iv': 1,
        'dance & media communications i': 1,
        'dance i': 1,
        'dance ii': 1,
        'dance iii': 1,
        'dance iv': 1,
        'dance perform ensemble i': 1,
        'dance perform ensemble ii': 1,
        'dance perform ensemble iii': 1,
        'dance perform ensemble iv': 1,
        'directing for the stage': 1,
        'general music, deptlized grd 6': 1,
        'general music, grade 7': 1,
        'general music, grade 8': 1,
        'ib art design sl-b': 1,
        'ib art/design hl': 1,
        'ib art/design sl-a': 1,
        'ib dance - hl': 1,
        'ib dance - sl': 1,
        'ib music hl': 2,
        'ib music sl': 2,
        'ib theatre arts hl': 1,
        'ib theatre arts sl': 1,
        'ib thtre/film - hl': 1,
        'ib thtre/film - sl': 1,
        'jazz improv i': 1,
        'jazz improv iv': 1,
        'intermed act: comedy & improv': 1,
        'music & media communication ii': 1,
        'music & media communications i': 1,
        'music i band': 1,
        'music i choir': 1,
        'music i history': 1,
        'music i instrumental ensemble': 1,
        'music i jazz band': 1,
        'music i orchestra': 1,
        'music i theory': 1,
        'music i vocal ensemble': 1,
        'music ii band': 1,
        'music ii choir': 1,
        'music ii instrumental ensemble': 1,
        'music ii jazz band': 1,
        'music ii orchestra': 1,
        'music ii theory': 1,
        'music ii vocal ensemble': 1,
        'music iii band': 1,
        'music iii choir': 1,
        'music iii instrument ensemble': 1,
        'music iii jazz band': 1,
        'music iii orchestra': 1,
        'music iii vocal ensemble': 1,
        'music iv band': 1,
        'music iv choir': 1,
        'music iv instrumental ensemble': 1,
        'music iv jazz band': 1,
        'music iv orchestra': 1,
        'music iv vocal ensemble': 1,
        'music prod, level ii': 1,
        'music production i': 1,
        // 'music, grade 1': 1, // here because subject area is fine arts //deletion edit 2024
        // 'music, grade 2': 1, // here because subject area is fine arts //deletion edit 2024
        // 'music, grade 3': 1, // here because subject area is fine arts //deletion edit 2024
        // 'music, grade 4': 1, // here because subject area is fine arts //deletion edit 2024
        // 'music, grade 5': 1, // here because subject area is fine arts //deletion edit 2024
        'music, grade 6': 1,
        'music/band, grade 7': 1,
        'music/band, grade 8': 1,
        'music/band,departmental grd 6': 1,
        'music/choir, deptmental grd 6': 1,
        'music/choir, grade 7': 1,
        'music/choir, grade 8': 1,
        'music/inst ens, grd 7': 1,
        'music/instr ens, grd 8': 1,
        'music/jazz band, grd 7': 1,
        'music/jazz band, grd 8': 1,
        'music/orchestra, dept grd 6': 1,
        'music/orchestra, grd 7': 1,
        'music/orchestra, grd 8': 1,
        'musical theatre i': 1,
        'musical theatre ii': 1,
        'musical theatre iii': 1,
        'musical theatre iv': 1,
        'pe3:pe f/mind/body/spirit': 1,
        'physical theatre i': 1,
        'playwriting i': 1,
        'playwriting ii': 1,
        'playwriting iii': 1,
        'scenography i': 1,
        'scenography ii': 1,
        'scenography iii': 1,
        'scenography iv': 1,
        'stage cmbt/thtr mvmt': 1,
        'statistics and business decision making': 1,
        'technical theatre i': 1,
        'technical theatre ii': 1,
        'technical theatre iii': 1,
        'technical theatre iv': 1,
        'theatre & media communicatns i': 1,
        'theatre arts i': 1,
        'theatre arts ii': 1,
        'theatre arts iii': 1,
        'theatre arts iv': 1,
        'theatre departmentalized grd 6': 1,
        'theatre production i': 1,
        'theatre production ii': 1,
        'theatre production iii-th3prod': 1,
        'theatre production iv': 1,
        // 'theatre, grade 1': 1, // here because subject area is fine arts //deletion edit 2024
        // 'theatre, grade 2': 1, // here because subject area is fine arts //deletion edit 2024
        // 'theatre, grade 3': 1, // here because subject area is fine arts //deletion edit 2024
        // 'theatre, grade 4': 1, // here because subject area is fine arts //deletion edit 2024
        // 'theatre, grade 5': 1, // here because subject area is fine arts //deletion edit 2024
        'theatre, grade 6': 1,
        'theatre, grade 7': 1,
        'theatre, grade 8': 1,
        /* new courses added 2018-06-26 */
        "acting methods": 1,
        "acting styles:classic/commedia": 1,
        "acting styles:improv/monologue": 1,
        "acting styles:realism/post-war": 1,
        "ap art history": 1,
        "ap studio art:2-dim dsgn portf": 1,
        "ap studio art:3-dim dsgn portf": 1,
        "ap studio art:drwing portfolio": 1,
        "art i - art appreciation": 1,
        "art i-art & media communica. i": 1,
        "art ii - design i": 1,
        "art ii - digital art & media i": 1,
        "art ii": 1,
        "art ii, ceramics i": 1,
        "art ii, drawing i": 1,
        "art ii, fibers i": 1,
        "art ii, jewelry i": 1,
        "art ii, painting i": 1,
        "art ii, photography i": 1,
        "art ii, printmaking i": 1,
        "art ii, sculpture i": 1,
        "art ii-art&media communica. ii": 1,
        "art iii - design ii": 1,
        "art iii": 1,
        "art iii, ceramics ii": 1,
        "art iii, drawing ii": 1,
        "art iii, fibers ii": 1,
        "art iii, jewelry ii": 1,
        "art iii, painting ii": 1,
        "art iii, photography ii": 1,
        "art iii, printmaking ii": 1,
        "art iii, sculpture ii": 1,
        "art iii-digital art & media ii": 1,
        "art iv - design iii": 1,
        "art iv": 1,
        "art iv, ceramics iii": 1,
        "art iv, drawing iii": 1,
        "art iv, fibers iii": 1,
        "art iv, jewelry iii": 1,
        "art iv, painting iii": 1,
        "art iv, photography iii": 1,
        "art iv, printmaking iii": 1,
        "art iv, sculpture iii": 1,
        "art iv-digital art & media iii": 1,
        "dance - middle school 1": 1,
        "dance - middle school 2": 1,
        "dance - middle school 3": 1,
        "dance i - ballet i": 1,
        "dance i - dance production i": 1,
        "dance i - dance theory i": 1,
        "dance i - dance wellness i": 1,
        "dance i - jazz i": 1,
        "dance i - tap i": 1,
        "dance i - world dance forms i": 1,
        "dance i, principles of dance i": 1,
        "dance i-dance & media comm i": 1,
        "dance i-dance comp/improv i": 1,
        "dance i-modern/contemporary i": 1,
        "dance i-performance/ensemble i": 1,
        "dance ii - ballet ii": 1,
        "dance ii - dance production ii": 1,
        "dance ii - dance wellness ii": 1,
        "dance ii - jazz ii": 1,
        "dance ii - tap ii": 1,
        "dance ii, dance theory ii": 1,
        "dance ii, dance&media comm ii": 1,
        "dance ii, principls of dnce ii": 1,
        "dance ii-dance comp/improv ii": 1,
        "dance ii-modern/contemp ii": 1,
        "dance ii-perform/ensemble ii": 1,
        "dance ii-world dance forms ii": 1,
        "dance iii - ballet iii": 1,
        "dance iii - dance history i": 1,
        "dance iii - dance theory iii": 1,
        "dance iii - dance wellness iii": 1,
        "dance iii - jazz iii": 1,
        "dance iii - tap iii": 1,
        "dance iii, perform/ensem iii": 1,
        "dance iii, princip of dnce iii": 1,
        "dance iii-danc comp/improv iii": 1,
        "dance iii-dance production iii": 1,
        "dance iii-modern/contemp iii": 1,
        "dance iii-wrld dance forms iii": 1,
        "dance iv - ballet iv": 1,
        "dance iv - dance production iv": 1,
        "dance iv - dance theory iv": 1,
        "dance iv - dance wellness iv": 1,
        "dance iv - jazz iv": 1,
        "dance iv, principls of dnce iv": 1,
        "dance iv, world dance forms iv": 1,
        "dance iv-dance comp/improv iv": 1,
        "dance iv-modern/contemp iv": 1,
        "dance iv-perform/ensemble iv": 1,
        "fine arts, subst, com-bsed pgm": 1,
        "ib dance i standard level": 1,
        "ib dance ii higher level": 1,
        "ib visual arts higher level": 1,
        "ib visual arts standard level": 1,
        "movement for the actor": 1,
        "music i - guitar i": 1,
        "music i - harp i": 1,
        "music i - jazz improvisation i": 1,
        "music i - mariachi i": 1,
        "music i - piano i": 1,
        "music i, applied music i": 1,
        "music i, band i": 1,
        "music i, choir i": 1,
        "music i, instrumental ensem i": 1,
        "music i, jazz ensemble i": 1,
        "music i, orchestra i": 1,
        "music i, vocal ensemble i": 1,
        "music i-world music ensemble i": 1,
        "music ii - guitar ii": 1,
        "music ii - harp ii": 1,
        "music ii - jazz improv ii": 1,
        "music ii - mariachi ii": 1,
        "music ii - piano ii": 1,
        "music ii instrumental ensem ii": 1,
        "music ii, applied music ii": 1,
        "music ii, band ii": 1,
        "music ii, choir ii": 1,
        "music ii, jazz ensemble ii": 1,
        "music ii, orchestra ii": 1,
        "music ii, vocal ensemble ii": 1,
        "music ii-wrld music ensembl ii": 1,
        "music iii - applied music iii": 1,
        "music iii - guitar iii": 1,
        "music iii - harp iii": 1,
        "music iii - jazz improv iii": 1,
        "music iii - mariachi iii": 1,
        "music iii - piano iii": 1,
        "music iii instrumntl ensem iii": 1,
        "music iii, band iii": 1,
        "music iii, choir iii": 1,
        "music iii, jazz ensemble iii": 1,
        "music iii, orchestra iii": 1,
        "music iii, vocal ensemble iii": 1,
        "music iii-wrld music ensbl iii": 1,
        "music iv - applied music iv": 1,
        "music iv - guitar iv": 1,
        "music iv - harp iv": 1,
        "music iv - jazz improv iv": 1,
        "music iv - mariachi iv": 1,
        "music iv - piano iv": 1,
        "music iv, band iv": 1,
        "music iv, choir iv": 1,
        "music iv, instrumentl ensem iv": 1,
        "music iv, jazz ensemble iv": 1,
        "music iv, orchestra iv": 1,
        "music iv, vocal ensemble iv": 1,
        "music iv-wrld music ensembl iv": 1,
        "music studies - music busn i": 1,
        "music studies - music comp i": 1,
        "music studies - music comp ii": 1,
        "music studies - music prod i": 1,
        "music studies - music prod ii": 1,
        "music studies - music theory i": 1,
        "music studies-music apprec. i": 1,
        "music studies-music apprec. ii": 1,
        "music studies-music theory ii": 1,
        "music studies-music&med comm i": 1,
        "music studies-music&med commii": 1,
        "tech theatr ii-dsgn for theatr": 1,
        "tech theatr ii-mkeup for theat": 1,
        "tech theatr iii-adv dsgn theat": 1,
        "tech theatr iii-mkup for theat": 1,
        "tech theatr iv-adv cstume cnst": 1,
        "tech theatr iv-adv desn theatr": 1,
        "tech theatre ii-costume const": 1,
        "tech theatre ii-theater mgt": 1,
        "tech theatre iii-adv cst const": 1,
        "tech theatre iii-adv light&snd": 1,
        "tech theatre iii-adv stagecrft": 1,
        "tech theatre iii-adv theat mgt": 1,
        "tech theatre iv-adv light&snd": 1,
        "tech theatre iv-adv stagecraft": 1,
        "tech theatre iv-adv theat mgt": 1,
        "technical theatre ii-lgt & snd": 1,
        "technical theatre ii-stagecrft": 1,
        "theatre i, theatre arts i": 1,
        "theatre i, theatre prod i": 1,
        "theatre i-theatre&media comm i": 1,
        "theatre ii, theatre arts ii": 1,
        "theatre ii, theatre prod ii": 1,
        "theatre ii-theatr&media com ii": 1,
        "theatre iii - directing i": 1,
        "theatre iii - playwriting i": 1,
        "theatre iii, theatre arts iii": 1,
        "theatre iii, theatre prod iii": 1,
        "theatre iv - directing ii": 1,
        "theatre iv - playwriting ii": 1,
        "theatre iv, theatre arts iv": 1,
        "theatre iv, theatre prod iv": 1,
        "art, ib visual arts sl": 2,
        "dance, level iii, ib dance i": 1,
        "theatre, ib theatre hl": 2,
        "art, ib visual arts hl": 2,
        //"music studies, ib music hl": 1, //deletion edit 2024
        "theatre, ib theatre sl": 2,
        // "music studies, ib music sl": 1, //deletion edit 2024
        "dance iv - tap iv": 1,
        "tech theatr iv-mkup for theatr": 1,
    }
};
//# sourceMappingURL=fineArts.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/core/fineArts.js
// module id = 444
// module chunks = 22